/* eslint-disable no-unused-vars */
<template id="graphSection">
    <apexchart class="graphPosition" :width="graphConfig.width" :height="graphConfig.height" :type="graphConfig.type" :options="options" :series="series"></apexchart>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

  export default {
    name: "DonutChart",
    props: {
      graphConfig: Object,
      chartHeight: Number,
      series: Array
    },
    components: {
      apexchart: VueApexCharts,
    }, 
    watch: {
      // eslint-disable-next-line no-unused-vars
      chartHeight(next, last){
        // console.log('next :>> ', next);
        // console.log('last :>> ', last);
        // eslint-disable-next-line no-unused-vars
        document.querySelectorAll(".graphPosition").forEach((element, index, array) => {
          if(!element)
            return

          element.style.height = `${this.chartHeight}px`
          element.style.maxHeight = `${this.chartHeight}px`
        })
      }
    },
    data: function() {
      return {
        options: {
          chart: {
          },
          plotOptions: {
            pie: {
              customScale: 1,
              dataLabels: {
                  offset: 0,
                  minAngleToShowLabel: 10
              },
              donut: {
                background: 'transparent',
                labels: {
                  show: false,
                  name: { 
                    show: true,  
                    offsetY: -10,                                                    
                  },
                  value: { 
                    show: false, 
                    fontSize: '26px',
                    fontWeight: "bold",
                    offsetY: 0,
                  },
                  total: {
                    show: false,
                    color: "#000000",
                    fontWeight: "bold",
                    showAlways: true,
                    label: this.$t('total'),
                  },                  
                },
              },
              expandOnClick: false
            },            
          },
          legend: {
            show: false,
            position: 'right',
            offsetX: 10,
            offsetY: 30,
            horizontalAlign: 'left',
            onItemClick: {
              toggleDataSeries: false
            },
          },
          fill: {
            type: 'gradient',
          },
          colors:["#000000", "#d11e1d"],
          dataLabels: {
            enabled: false,
            textAnchor: 'middle',
            style: {
              fontWeight: '100',
              colors: ['#000']
            }, 
            background: {
              enabled: true,
              foreColor: '#fff',
              padding: 4,
              borderRadius: 2,
              borderWidth: 1,
              borderColor: '#fff',
              opacity: 0.9,
              dropShadow: {
                enabled: false,
                top: 1,
                left: 1,
                blur: 1,
                color: '#000',
                opacity: 0.45
              }
            },       
            formatter: function (val, data) {
              // return val + "%"
              // console.log('val :>> ', val);
              // console.log('w :>> ', data);
              // console.log('data.seriesIndex :>> ', data.seriesIndex);
              return data.w.globals.series[data.seriesIndex]
            },
          },          
          labels: [this.$t('no-prazo'), this.$t('em-atraso')]
        },
      }
    },
    created(){
      // console.log('graphConfig :>> ', this.graphConfig);
      // console.log('this.chartHeight - Chart - Create :>> ', this.chartHeight);
    }   
  }
</script>

<style scoped>

.graphPosition {  
  display: grid;
  justify-content: center;
  align-self: center;
  width: 100%;
}


</style>